/** The public website uses the same date bounds before and after hydration.
 * This does not change the Telegram Mini App's retained-offer policy. */
type Period = { valid_from?: string; valid_until?: string };
type DatedOffer = { offer_notice?: Period };
const day = (value: string | undefined) => /^\d{4}-\d{2}-\d{2}$/.test(value ?? "") ? value! : "";

export function websiteOfferPeriod(product: DatedOffer, catalog: Period): Period {
  const starts = [day(catalog.valid_from), day(product.offer_notice?.valid_from)].filter(Boolean).sort();
  const ends = [day(catalog.valid_until), day(product.offer_notice?.valid_until)].filter(Boolean).sort();
  return { valid_from: starts.at(-1) ?? "", valid_until: ends[0] ?? "" };
}

export function websiteOfferActive(product: DatedOffer, catalog: Period, today: string): boolean {
  const period = websiteOfferPeriod(product, catalog);
  return Boolean(day(today) && period.valid_until && period.valid_until >= today
    && (!period.valid_from || period.valid_from <= today));
}
